import { render, staticRenderFns } from "./doubleBars.vue?vue&type=template&id=490f9398&scoped=true&"
import script from "./doubleBars.vue?vue&type=script&lang=js&"
export * from "./doubleBars.vue?vue&type=script&lang=js&"
import style0 from "./doubleBars.vue?vue&type=style&index=0&id=490f9398&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490f9398",
  null
  
)

export default component.exports